import styled from "@emotion/styled";

export const Background = styled.path`
  fill: var(--color-base-neutral80);
`;
